import { selector } from "recoil";
import { accountsFilterState, accountsState } from "./atoms";

export const filteredAccountsState = selector({
    key: 'filteredAccountsState',
    get: ({ get }) => {
        const filter = get(accountsFilterState)
        const accounts = get(accountsState)
        return accounts.filter(account => account.title.includes(filter) || account.bank_name.includes(filter) || account.branch_name.includes(filter) || account.number.toString().includes(filter) || account.owner.includes(filter) || account.cheque_setting_title.includes(filter))
    }
})